import { options } from './editorConfig';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import './styles.css';

interface EditorTextoProp {
    editorState: string;
    setEditorState: any;
}

const EditorTexto = (prop: EditorTextoProp) => {
    
    return (
        <>
            <div className="sun-editor">
                <SunEditor
                    setOptions={options}
                    setContents={prop.editorState}
                    onChange={prop.setEditorState}
                    defaultValue={prop.editorState}
                    lang="pt_br"
                    setDefaultStyle="font-family: Arial; font-size: 14px;"
                />
            </div>
        </>
    );
};

export default EditorTexto;